<app-page-content [showSearchBox]="true" (search)="navigateWithNewParameters()" [(searchQuery)]="searchQuery" [showProgress]="progress" [enableMenuButton]="true">
  <span pagetitle>Alle sendinger</span>

  <div style="display: flex; flex-direction: row" pageheaderactions>
    <app-select-box *ngIf="!coreConfiguration.isMobile" style="width: 160px; margin: auto 0 auto 0.5em" [value]="currentStatus == null ? 'Alle statuser' : currentStatus | shipmentStatusFilterName">
      <button mat-menu-item (click)="changeFilteredStatus(null)">Alle statuser</button>
      <button mat-menu-item *ngFor="let status of filterableStatuses" (click)="changeFilteredStatus(status)">{{ status | shipmentStatusFilterName }}</button>
    </app-select-box>

    <app-select-box *ngIf="!coreConfiguration.isMobile && departments.length > 0" style="width: 200px; margin: auto 0 auto 0.5em" [value]="currentDepartment == null ? 'Alle avdelinger' : currentDepartment.Name">
      <button mat-menu-item (click)="changeFilteredDepartment(null)">Alle avdelinger</button>
      <button mat-menu-item *ngFor="let department of departments" (click)="changeFilteredDepartment(department)">{{ department.Name }}</button>
    </app-select-box>

    @if (!coreConfiguration.isMobile) {
      @if (carriers.length > 20) {
        <app-carrier-search-input (carrierSelected)="changeFilteredCarrier($event)" style="width: 250px; margin: auto 0 auto 0.5em" [value]="currentCarrier">

        </app-carrier-search-input>
      } @else {
        <app-select-box style="width: 150px; margin: auto 0 auto 0.5em" [value]="currentCarrier == null ? 'Alle bærere' : currentCarrier.Name">
          <button mat-menu-item (click)="changeFilteredCarrier(null)">Alle bærere</button>
          <button mat-menu-item *ngFor="let carrier of carriers" (click)="changeFilteredCarrier(carrier)">{{ carrier.Name }}</button>
        </app-select-box>
      }
    }

    <app-date-picker style="width: 250px; margin: auto 0 auto 0.5em" [value]="currentDateFilterValue" (valueChanged)="currentDateValueChanged($event)"></app-date-picker>
  </div>

  <div pagecontent>
    <app-shipment-list *ngIf="!coreConfiguration.isMobile" [headersVisible]="false" [showStatusColumn]="true" [multipleSelect]="multiple"
                       [showDeviationColumn]="true" [showUserColumn]="true" (selectionToggled)="selectionToggled($event)" [shipments]="shipments"
                       (sortChanged)="sortChanged($event)"></app-shipment-list>

    <app-list *ngIf="coreConfiguration.isMobile">
      <app-shipment-item *ngFor="let item of shipments" [shipment]="item" (click)="showShipment(item)"></app-shipment-item>
    </app-list>
  </div>

  <div style="display: flex; flex-direction: row" pagefooter>
    <app-button-box style="margin: auto" *ngIf="!coreConfiguration.isMobile">
      <button mat-raised-button color="primary" *ngIf="selectedShipments.length == 0" (click)="toggleMultipleSelect()">{{ multiple ? 'VELG EN' : 'VELG FLERE' }}</button>
      <button mat-raised-button color="primary" *ngIf="selectedShipments.length > 0" (click)="clearSelection()">NULLSTILL</button>
      <button mat-raised-button color="warn" style="margin-left: 0.5em" *ngIf="selectedShipments.length > 0" (click)="queryDeleteSelectedShipments()">SLETT VALGTE</button>
    </app-button-box>

    <span style="flex: 1 1 auto"></span>

    <app-paginator style="margin: auto"
                   [totalCount]=totalShipmentCount
                   [pageSize]=currentPageSize
                   [pageSizeOptions]="[20, 50, 100, 200]"
                   [pageIndex]=currentPage
                   [enablePageSizeSelector]="!coreConfiguration.isMobile"
                   (page)="changePage($event)">
    </app-paginator>
  </div>
</app-page-content>

